<template>
  <div v-on-clickout="()=>{dropdown=false}" class="obj-field w-clearfix">
    <a @click="downloadData()" href="#" class="top-right-align">Download Data</a>
    <div>
      <!--		<router-link :to="'item/'+$route.params.col+'/'+ $route.params.id+'/pop/up/'+ Col +'/new-item/'" href="#" class="blue-txt top-marg5">+ Add New</router-link>-->
      <div
        v-if="!$parent.popsicle"
        class="blue-txt top-marg5"
        @click="newItem($attrs.validations.collectionId)"
      >+ Add New</div>
      <input
        :editable="editable"
        ref="input"
        @keyup.down="setFocus(0)"
        @focus="editable!==false?dropdown=true:''"
        v-model="searchterm"
        type="text"
        :placeholder="'Find '+fname"
        class="search multi w-input"
        maxlength="256"
      />
      <div class="dropdown-list" v-if="dropdown">
        <ul class="list w-list-unstyled">
          <li
            class="ddown-list w-clearfix srf-ddown"
            v-for="(item,i) in trueFields"
            :key="item._id+i"
            :ref="'li'+i"
            @keydown="focusUp($event)"
            @keyup.down="setFocus(i+1)"
            @keyup.up="setFocus(i-1)"
            @keyup.enter="addItem(item._id)"
            :tabindex="i"
            @click="addItem(item._id)"
          >{{item.name}}</li>
        </ul>
      </div>
    </div>
    <div v-if="!finished" style="text-align:center; padding-bottom:10px;">
      <Spinner :zoom="0.6" color="#4D8CF4" />
    </div>
    <draggable
      v-if="finished && (!$parent.$parent.popup || $parent.popsicle)"
      v-model="selItems"
      @start="drag=true"
      @end="drag=false"
    >
      <a
        v-for="element in $parent.info[slg]"
        :key="element"
        @dblclick="$parent.$parent.popup = Col+'/'+element"
        class="inner-item"
        :class="archiveFinder(element)?'archived':''"
      >
        <div class="dotss w-inline-block"></div>
        <p class="inner-item-txt">{{namefinder(element)}}</p>
        <p v-if="editable!==false" @click="removeItem(element)" class="link-block-2 w-inline-block"></p>
      </a>
    </draggable>
  </div>
</template>

<style scoped>
.inner-item.archived {
  background: darkgrey;
}
.blue-txt {
  cursor: pointer;
}
div {
  outline: none;
}
.rtl .search {
  background-position: 99% 50%;
}
</style>

<script>
import { mixin as clickout } from "vue-clickout";
import draggable from "vuedraggable";
import Spinner from "@/uiComponents/spinnerLoading.vue";

export default {
  mixins: [clickout],
  components: {
    draggable,
    Spinner
  },
  name: "ItemRefSet",
  props: ["slg", "fname", "index", "editable"],

  data() {
    return {
      rendered: [],
      dropdown: false,
      searchterm: "",
      finished: false,
      selItems: [],
      Col: ""
    };
  },
  methods: {
    downloadData() {
      // console.log(window.downloadCSV);
      downloadCSV(this.Col, this.$parent.info[this.slg]);
    },
    focusUp(e) {
      var key = e.keyCode;
      if (key != 40 && key != 38 && key != 13) {
        this.$refs.input.focus();
      }
    },
    setFocus(i) {
      if (this.$refs["li" + i] && this.$refs["li" + i][0] != undefined) {
        this.$refs["li" + i][0].focus();
      }
    },
    newItem(id) {
      this.$parent.$parent.popup = id + "/new-item/" + this.$props.slg + "/set";
      //  console.log("a popup should come up now")
    },
    addItem(id) {
      //if (!this.$parent.info[this.slg]){this.$parent.info[this.slg]=[]}
      this.selItems.push(id);
      //this.$parent.info[this.slg].push(id)
      this.dropdown = false;
    },
    archived(id) {
      //return false
      return this.$parent.$parent.items[
        this.$attrs.validations.collectionId
      ].find(e => {
        return e._id === id;
      })._archived;
    },
    removeItem(id) {
      for (var i = 0; i < this.$parent.info[this.slg].length; i++) {
        if (this.$parent.info[this.slg][i] === id) {
          this.$parent.info[this.slg].splice(i, 1);
        }
      }
    },
    selectify() {
      if (this.$parent.info[this.slg]) {
        this.$parent.info[this.slg] = "";
      }
    },
    namefinder(id) {
      var item = this.$parent.$parent.items[
        this.$attrs.validations.collectionId
      ].find(e => e._id === id);
      console.log(item);
      if (!item) {
        return "Item Deleted";
      }
      if (!this.rendered.includes(item)) {
        this.rendered.push(item);
      }
      return item.name;
    },

    archiveFinder(id) {
      if (
        !this.$parent.$parent.items[this.$attrs.validations.collectionId].find(
          e => {
            return e._id === id;
          }
        )
      ) {
        return true;
      }
      return this.$parent.$parent.items[
        this.$attrs.validations.collectionId
      ].find(e => {
        return e._id === id;
      })._archived;
    },
    sortable() {
      var el = this.$refs[id];
      new Sortable(el, {
        animation: 150,
        ghostClass: "blue-background-class"
      });
    },
    updateSelection(id) {
      this.$parent.info[this.slg] = id;
      this.dropdown = false;
      var item = this.$parent.$parent.items[
        this.$attrs.validations.collectionId
      ].find(e => e._id === id);
      this.searchterm = item.name;
    },
    getData(Col) {
      if (!this.$parent.$parent.items[Col]) {
        this.$parent.$parent.items[Col] = [];
        getdata.firebase(Col, res => {
          res.forEach(element => {
            this.$parent.$parent.items[Col].push(element);
          });
          this.loader = false;
          this.finished = true;
        });
      } else {
        this.finished = true;
      }
    },
    searchable(arr, arr2, regex) {
      if (!regex) {
        regex = /./;
      }
      var newarr = [];
      $.each(arr, (i, e) => {
        if (!arr2.includes(e) && e.match(new RegExp(regex, "i"))) {
          newarr.push(e);
        }
      });
      return newarr;
    }
  },
  mounted() {
    if (this.$parent.info[this.slg]) {
      this.selItems = this.$parent.info[this.slg];
    }
    window.appp = this;
    this.Col = this.$attrs.validations.collectionId;
    this.getData(this.Col);
  },
  computed: {
    trueFields() {
      var regex;
      this.searchterm ? (regex = this.searchterm) : (regex = /./);
      if (this.$parent.$parent.items[this.$attrs.validations.collectionId]) {
        var newarr = [];
        $.each(
          this.$parent.$parent.items[this.$attrs.validations.collectionId],
          (i, e) => {
            if (
              e.name.match(new RegExp(regex, "i")) &&
              !this.selItems.includes(e._id) &&
              !e._archived
            ) {
              newarr.push(e);
            }
          }
        );
        return newarr;
      } else {
        return [];
      }
    }
  },
  watch: {
    selItems() {
      if (!this.$parent.info[this.slg]) {
        this.$parent.info[this.slg] = [];
      }
      this.$parent.info[this.slg] = this.selItems;
    }
  }
};
</script>